var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.7198V4.27982C21.0045 4.12563 20.9733 3.97248 20.9088 3.83235C20.8443 3.69222 20.7483 3.56891 20.6282 3.47208C20.5081 3.37524 20.3672 3.30749 20.2166 3.27414C20.066 3.24079 19.9097 3.24273 19.76 3.27982L9 5.99982V13.9998L19.76 16.6898C19.9072 16.7262 20.0608 16.7287 20.2092 16.6969C20.3575 16.6652 20.4967 16.6001 20.6161 16.5067C20.7356 16.4132 20.8323 16.2938 20.8988 16.1575C20.9653 16.0212 20.9999 15.8715 21 15.7198Z",
    stroke: "#3A3428",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 14V20C9.00016 20.2652 8.8948 20.5196 8.70726 20.7071C8.51973 20.8946 8.26537 21 8.00016 21H6.82016C6.58621 21.0047 6.35802 20.9272 6.1753 20.7811C5.99258 20.6349 5.86691 20.4293 5.82016 20.2L4.41016 13",
    stroke: "#3A3428",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H7C5.93913 6 4.92172 6.42143 4.17157 7.17157C3.42143 7.92172 3 8.93913 3 10C3 11.0609 3.42143 12.0783 4.17157 12.8284C4.92172 13.5786 5.93913 14 7 14H9V6Z",
    stroke: "#3A3428",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchIcon);
export default __webpack_public_path__ + "static/media/LaunchIcon.d41322e3f4165d28d9a88f98c7a22e4e.svg";
export { ForwardRef as ReactComponent };